module.exports = __webpack_public_path__ + "img/24-image-1-1@2x.121ee2e2.png";